import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss']
})
export class IconPickerComponent implements OnInit {
  icons: string[] = new Array(64);

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    for (let i = 0; i < this.icons.length; i++) {
      this.icons[i] = '&#xe' + (2304 + i).toString(16);
    }
  }

  onIconClick(icon) {
    this.activeModal.close({icon});
    document.body.classList.add('modal-open');
  }

  closeIcon() : void {
    this.activeModal.dismiss();  
    document.body.classList.add('modal-open');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/icon-picker/icon-picker.component.ts